
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{

  display:block;

  border-radius:1.5rem;

  background-color:var(--neutral-white);

  padding:1rem;
}@media (min-width: 768px){:host{

    padding:1.5rem;
  }
}@media (min-width: 1024px){:host{

    padding:2rem;
  }
}:host{

  box-shadow:var(--brand-shadow-lg);
}

.provider-card{

  display:flex;

  flex-direction:column;

  gap:1.5rem;
}

@media (min-width: 768px){.provider-card{

    flex-direction:row;
  }.provider-card{

    gap:2rem;
  }
}

::slotted([slot='image']){

  width:8rem;

  flex-shrink:0;
}

@media (min-width: 768px){::slotted([slot='image']){

    width:12rem;
  }
}

@media (min-width: 1024px){::slotted([slot='image']){

    width:16rem;
  }
}

.content{

  flex:1 1 0%;
}

.heading{

  color:var(--primary-blue);
}

.sub-heading{

  font-family:var(--ff-display);

  font-size:var(--fs-lg);

  line-height:var(--lh-lg);

  font-weight:var(--fw-medium);

  color:var(--neutral-gray-1);
}

.divider{

  margin-top:1rem;

  margin-bottom:1rem;

  border-width:0px;

  border-bottom-width:1px;

  border-style:solid;

  border-color:var(--neutral-gray-4);
}

@media (min-width: 768px){.divider{

    margin-top:1.5rem;

    margin-bottom:1.5rem;
  }
}

@media (min-width: 1280px){.divider{

    margin-top:2rem;

    margin-bottom:2rem;
  }
}

.details{

  margin-bottom:1.5rem;

  display:flex;

  flex-wrap:wrap;

  row-gap:1.5rem;
}

@media (min-width: 768px){.details{

    margin-bottom:3rem;
  }
}

@media (min-width: 1024px){.details{

    justify-content:space-between;
  }
}

.details ::slotted(ghs-provider-detail){

  width:100% !important;

  border-width:0px !important;
}

@media (min-width: 768px){.details ::slotted(ghs-provider-detail){

    width:50% !important;
  }.details ::slotted(ghs-provider-detail){

    flex:1 1 auto !important;
  }.details ::slotted(ghs-provider-detail){

    border-right-width:1px !important;
  }.details ::slotted(ghs-provider-detail){

    border-style:solid !important;
  }.details ::slotted(ghs-provider-detail){

    border-color:var(--neutral-gray-4) !important;
  }.details ::slotted(ghs-provider-detail){

    padding-left:1.5rem !important;

    padding-right:1.5rem !important;
  }
}

@media (min-width: 1024px){.details ::slotted(ghs-provider-detail){

    width:auto !important;
  }
}

@media (min-width: 768px){.details ::slotted(ghs-provider-detail:nth-child(odd)){

    border-width:0px !important;
  }
}

@media (min-width: 1024px){.details ::slotted(ghs-provider-detail:nth-child(odd)){

    border-right-width:1px !important;
  }
}

.details ::slotted(ghs-provider-detail[term='Reviews']){

  border-width:0px !important;
}

.actions{

  display:flex;

  flex-wrap:wrap;

  column-gap:1rem;

  row-gap:1rem;
}

@media (min-width: 768px){.actions{

    column-gap:1.5rem;
  }
}
`;